<template>
  <div>
    <b-form @submit="onSubmit">
      <b-form-group :label="$t('share.content.twitter_form_message')">
        <b-form-textarea required
                         rows=3
                         v-model="form.message">
        </b-form-textarea>
      </b-form-group>
      <div class="icon-panel">
        <b-col class="text-right">
          <b-button type="submit" variant="primary">{{$t('share.content.twitter_form_submit_btn')}}</b-button>
        </b-col>
      </div>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'Twitter',
  data() {
    return {
      form: {
        message: ""
      }
    }
  },
  methods: {
    onSubmit() {
      event.preventDefault()
      this.$emit('submit', {message: this.form.message})
    }
  },
  created() {
    this.$emit('loaded')
  }
}
</script>
